import request from '@/utils/request'

const purchaseApi = process.env.VUE_APP_PURCHASE_API

// 查询自己的报价唱标信息
export function getBidderQuoteOpenMarkPageApi(projectId, bidderId, params) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/supplier/kpb/projects/v2/${projectId}/offer-open/bidders/${bidderId}/owner-info`,
    method: 'get',
    params
  })
}

// 分页查询所有报价唱标列表
export function getOtherBidderQuoteOpenMarkPageApi(
  projectId,
  bidderId,
  params
) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/supplier/kpb/projects/v2/${projectId}/offer-open/bidders/${bidderId}/marks/page`,
    method: 'get',
    params
  })
}
